// extracted by mini-css-extract-plugin
export default {"separator":"WalletPreferences_separator__-tQSZ"};